module.exports = __webpack_public_path__ + "img/voltaje_c_blue.3bc0b12e.svg";